import { useState } from "react"

import AIReportTable from "./AIReportTable"
import AIReportDialog from "./AIReportDialog"
import { createAccountStore } from "@/stores/account"
import useRouter from "@/hooks/router/useRoute"

import "./aiReport.scss"

export default function AIReportPage() {
  const { teamProfileInfo } = createAccountStore()
  const router = useRouter()

  if (!teamProfileInfo?.teamPermissions?.ACCESS_AI_REPORT) {
    router.push("/home")
    return null
  }

  const [selectedIdfReport, setSelectedIdfReport] = useState<number | null>(null)
  const [dialogOpen, setDialogOpen] = useState(false)

  const handleRowClick = (idfReport: number) => {
    setSelectedIdfReport(idfReport)
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
    setSelectedIdfReport(null)
  }

  return (
    <div className="AIReportPageCont">
      <AIReportTable onRowClick={handleRowClick} />
      {selectedIdfReport !== null && (
        <AIReportDialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          idfReport={selectedIdfReport}
        />
      )}
    </div>
  )
}
